export const zoomLevels = ['DAYS', 'WEEKS', 'MONTHS', 'QUARTERS', 'YEARS'];
